import styled from "styled-components";

export const LoadingContent = styled.div`
  margin-top: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
